// Autogenerated by `yarn version-file`. DO NOT EDIT
export var VERSION = '1.28.18';
//# sourceMappingURL=version.js.map